<div class="animated fadeIn" style="overflow: hidden;">
    <div class="card">

        <div class="card-body" [style]="{'border': '1px solid red!important;'}">

            <div>


                <p-table #dt [columns]="cols" [loading]="loading" selectionMode="single" scrollHeight="550px"
                    [(selection)]="selectedHebergement" [value]="hebergementsObservable | async" [scrollable]="true">
                    <ng-template pTemplate="colgroup" let-columns>
                        <colgroup>
                            <col *ngFor="let col of columns" style="width:250px">
                        </colgroup>
                    </ng-template>

                    <ng-template pTemplate="caption">
                        <div class="ui-helper-clearfix" style="text-align: left">

                            <button pButton icon="pi pi-times" (click)="removeHebergement()" label='Remove'
                                [disabled]='!selectedHebergement' class="btn btn-sm btn-def">

                            </button>

                            <button pButton icon="pi pi-pencil" (click)="prepareEditHebergement()" label='Editer'
                                [disabled]='!selectedHebergement' class="btn btn-sm btn-def">
                            </button>
                            <button pButton icon="pi pi-plus" (click)="prepareHebergement()" label='New'
                                class="btn btn-sm btn-def">
                            </button>
                            <button style="float: right;width:auto" pButton icon="pi pi-file-pdf" iconPos="left"
                                label="PDF" (click)="exportPdf()" class="btn-def"></button>
                            <input type="text" style="float: right;width:auto" pInputText placeholder="Global Filter"
                                (input)="dt.filterGlobal($event.target.value, 'contains')">
                            <i class="fa fa-search" style="margin:4px 4px 0 0;float: right;"></i>
                            <span *ngIf='hebergements' style="float: right;">

                                {{hebergements.length}} Hebergements
                            </span>


                        </div>
                    </ng-template>
                    <ng-template pTemplate="header" let-columns>


                        <tr>
                            <th *ngFor="let col of columns" [style.width]="col.width" [pSortableColumn]="col.field">
                                {{col.header}} <p-sortIcon [field]="col.field"></p-sortIcon>
                            </th>
                        </tr>
                        <tr>
                            <th *ngFor="let col of columns" [ngSwitch]="col.field">



                                <p-dropdown appendTo="body" *ngSwitchCase="'payee'" [options]="ouiNon"
                                    [style]="{'width':'100%'}"
                                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>


                                <p-dropdown appendTo="body" *ngSwitchCase="'publicite'" [options]="ouiNon"
                                    [style]="{'width':'100%'}"
                                    (onChange)="dt.filter($event.value, col.field, 'equals')"></p-dropdown>

                                <input *ngSwitchDefault pInputText type="text"
                                    (input)="dt.filter($event.target.value, col.field, 'contains')">

                            </th>
                        </tr>



                    </ng-template>
                    <ng-template pTemplate="body" let-rowData let-columns="columns">
                        <tr [pSelectableRow]="rowData">



                            <td *ngFor="let col of columns" [ngSwitch]="col.field">
                                <span *ngSwitchCase="'date_arrive'">
                                    {{rowData.date_arrive | date :'dd/MM/yyyy hh:mm'}}</span>
                                <span *ngSwitchCase="'date_depart'">
                                    {{rowData.date_depart | date :'dd/MM/yyyy hh:mm'}}</span>
                                <span *ngSwitchCase="'payee'"> <span *ngIf="rowData.payee">Payé</span> <span
                                        *ngIf="!rowData.payee">Non Payé</span></span>
                                <span *ngSwitchCase="'factureClient'">
                                    <p-fileUpload [ngStyle]="{'float': 'left','margin-left':'5px'}"
                                        (click)="selectUpload(rowData,'client')" name="name" url="{{uploadUrl}}"
                                        mode="basic" auto="true" chooseLabel="." (onUpload)="uploadFunction($event)"
                                        [multiple]="false" maxFileSize="100000000">

                                    </p-fileUpload>
                                    <button pButton [ngStyle]="{'float': 'left','margin-left':'5px'}" icon="pi pi-open"
                                        label="Ouvrir" *ngIf="rowData.factureClient"
                                        (click)="showFile(rowData,'client')"></button>

                                </span>

                                <span *ngSwitchCase="'factureHotel'">
                                    <p-fileUpload
                                        [ngStyle]="{'float': 'left','margin-left':'5px','backgroud-color':'red'}"
                                        (click)="selectUpload(rowData,'hotel')" name="name" url="{{uploadUrl}}"
                                        mode="basic" auto="true" chooseLabel="." (onUpload)="uploadFunction($event)"
                                        [multiple]="false" maxFileSize="100000000">

                                    </p-fileUpload>

                                    <button pButton [ngStyle]="{'float': 'left','margin-left':'5px'}" icon="pi pi-open"
                                        label="Ouvrir" *ngIf="rowData.factureHotel"
                                        (click)="showFile(rowData,'hotel')"></button>


                                </span>


                                <span *ngSwitchDefault> {{rowData[col.field]}}</span>

                            </td>





                        </tr>
                    </ng-template>



                </p-table>





            </div>
        </div>


    </div>

</div>

<p-dialog position="top" *ngIf="selectedHebergement" [(visible)]="isVisible" [modal]="true" [responsive]="true"
    [style]="{width: '900px',height: '700px', minWidth: '400px'}" [maximizable]="false" appendTo='body'>

    <p-header>Editer Hebergement</p-header>
    <div style="height: 600px;">


        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Hotel
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <p-dropdown [style]="{'width':'100%','margin-bottom':'5px'}" [options]="hotelsList"
                    [(ngModel)]="selectedHebergement.designation" [showClear]="true"></p-dropdown>

            </div>
        </div>

        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Client
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input pInputText type="text" [(ngModel)]="selectedHebergement.client">



            </div>
        </div>
        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Nom Prénom
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <input pInputText type="text" [(ngModel)]="selectedHebergement.nom_prenom">

            </div>
        </div>
        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Date arrivé
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <p-calendar (onSelect)='calculeNuitee()'  dateFormat="dd/mm/yy" [(ngModel)]="dateArrivee"
                    [showTime]="true"></p-calendar>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Date départ
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <p-calendar (onSelect)='calculeNuitee()' dateFormat="dd/mm/yy"   [(ngModel)]="dateDepart"
                    [showTime]="true"></p-calendar>
            </div>
        </div>


        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Nbr nuité
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <input pInputText type="number" [(ngModel)]="selectedHebergement.nbr_nuitee">
            </div>
        </div>

        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Prise eb charge
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <p-dropdown [style]="{'width':'100%','margin-bottom':'5px'}" [options]="priseEncharges"
                    [(ngModel)]="selectedHebergement.priseEnCharge" [showClear]="true"></p-dropdown>

            </div>
        </div>

        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Type de chambre
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <p-dropdown [style]="{'width':'100%','margin-bottom':'5px'}" [options]="typeChambres"
                    [(ngModel)]="selectedHebergement.type_chambre" [showClear]="true"></p-dropdown>

            </div>
        </div>
        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Transport
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <p-dropdown [style]="{'width':'100%','margin-bottom':'5px'}" [options]="ouiNonString"
                    [(ngModel)]="selectedHebergement.transport" [showClear]="true"></p-dropdown>

            </div>
        </div>
        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Payé
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">

                <p-inputSwitch [(ngModel)]="selectedHebergement.payee"></p-inputSwitch>

            </div>
        </div>




        <div class="row">
            <div class="col-xs-3 col-sm-3 col-md-3 col-lg-3">
                Note
            </div>
            <div class="col-xs-9 col-sm-9 col-md-9 col-lg-9">
                <textarea rows="5" style="width: 100%;" [(ngModel)]="selectedHebergement.observation"
                    pInputTextarea></textarea>

            </div>
        </div>


    </div>
    <footer>
        <button style="float: right;width: 200px;" pButton (click)="saveHebergement()" label='Editer' class="btn-def">
        </button>
    </footer>


</p-dialog>